import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const config = require('../config');

function Login() {
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const { data } = await axios.post(config.serverUrl + '/login', { username, password });
      localStorage.setItem('token', data.access_token);
      navigate('/');
    } catch (error) {
        setErrorMessage('Wrong username or password');
    }
  };

  return (
    <form onSubmit={handleSubmit} autocomplete="on" className='login-form'>
       <div>
        <label htmlFor="username">Username</label>
        <input id="username" type="text" value={username} onChange={e => setUsername(e.target.value)} autocomplete="username"/>
      </div>
      <div>
        <label htmlFor="password">Password</label>
        <input id="password" type="password" value={password} onChange={e => setPassword(e.target.value)} autocomplete="current-password" />
      </div>
      <button type="submit">Login</button>
      {errorMessage && <p>{errorMessage}</p>} 
    </form>
  );
}

export default Login;